import { useState, useMemo } from "react";

export function useAutocomplete(options: string[]) {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [openedByClick, setOpenedByClick] = useState(false);

  const filtered = useMemo(() => {
    if (!query && !openedByClick) return [];

    if (!query && openedByClick) return options;

    return options.filter((opt) => opt.toLowerCase().includes(query.toLowerCase()));
  }, [query, options, openedByClick]);

  const onChange = (value: string) => {
    setOpenedByClick(false);
    setQuery(value);
    setIsOpen(true);
  };

  const onClick = () => {
    // кликнули в поле
    if (!query) {
      setOpenedByClick(true);
    }
    setIsOpen(true);
  };

  const onSelect = (value: string) => {
    setQuery(value);
    setIsOpen(false);
    setOpenedByClick(false);
  };

  const close = () => {
    setIsOpen(false);
    setOpenedByClick(false);
  };

  return {
    query,
    isOpen,
    filtered,
    onChange,
    onSelect,
    onClick,
    close,
  };
}

// import { useState, useMemo } from "react";

// export function useAutocomplete(options: string[]) {
//   const [query, setQuery] = useState("");
//   const [isOpen, setIsOpen] = useState(false);

//   // фильтруем по введенному тексту
//   const filtered = useMemo(() => {
//     if (!query) return options;
//     return options.filter((opt) => opt.toLowerCase().includes(query.toLowerCase()));
//   }, [query, options]);

//   const onChange = (value: string) => {
//     setQuery(value);
//     setIsOpen(true);
//   };

//   const onSelect = (value: string) => {
//     setQuery(value);
//     setIsOpen(false);
//   };

//   const close = () => setIsOpen(false);

//   return {
//     query,
//     setQuery,
//     isOpen,
//     filtered,
//     onChange,
//     onSelect,
//     close,
//   };
// }
